import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PosProvider } from "@/context/PosContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Stocks from "@/pages/Stocks";
import Movements from "@/pages/Movements";
import Sales from "@/pages/Sales";
import Orders from "@/pages/Orders";
import Expenses from "@/pages/Expenses";
import ChargesFixes from "@/pages/ChargesFixes";
import Suppliers from "@/pages/Suppliers";
import UsersPage from "@/pages/Users";
import Reports from "@/pages/Reports";
import PointsDeVente from "@/pages/PointsDeVente";
import Distribution from "@/pages/Distribution";
import Destructions from "@/pages/Destructions";
import Glovo from "@/pages/Glovo";
import Freezer from "@/pages/Freezer";
import Production from "@/pages/Production";
import ActivityLog from "@/pages/ActivityLog";
import Taches from "@/pages/Taches";
import Crm from "@/pages/Crm";
import ApiSettings from "@/pages/ApiSettings";

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--tm-bg)" }}>
      <div className="text-center">
        <h1 className="font-display text-4xl tracking-tight" style={{ color: "var(--tm-gold)" }}>TIRAMESSI</h1>
        <div className="mt-4 mx-auto w-8 h-8 rounded-full tm-spin" style={{ border: "3px solid #262626", borderTopColor: "var(--tm-gold)" }} />
      </div>
    </div>
  );
}

function Protected({ children, adminOnly, perm }) {
  const { user, ready, isAdmin, can } = useAuth();
  if (!ready) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  if (perm && !can(perm, "view")) return <Navigate to="/" replace />;
  return children;
}

function LoginGate() {
  const { user, ready } = useAuth();
  if (!ready) return <Splash />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#141414", border: "1px solid #262626", color: "#F5F5DC" } }} />
      <AuthProvider>
        <PosProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginGate />} />
              <Route element={<Protected><Layout /></Protected>}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/produits" element={<Protected perm="produits"><Products /></Protected>} />
                <Route path="/production" element={<Protected perm="production"><Production /></Protected>} />
                <Route path="/stocks" element={<Protected perm="stocks"><Stocks /></Protected>} />
                <Route path="/mouvements" element={<Protected perm="mouvements"><Movements /></Protected>} />
                <Route path="/ventes" element={<Protected perm="ventes"><Sales /></Protected>} />
                <Route path="/glovo" element={<Protected perm="glovo"><Glovo /></Protected>} />
                <Route path="/congelateur" element={<Protected perm="congelateur"><Freezer /></Protected>} />
                <Route path="/commandes" element={<Protected perm="commandes"><Orders /></Protected>} />
                <Route path="/destructions" element={<Protected perm="destructions"><Destructions /></Protected>} />
                <Route path="/depenses" element={<Protected perm="depenses"><Expenses /></Protected>} />
                <Route path="/charges-fixes" element={<Protected perm="charges"><ChargesFixes /></Protected>} />
                <Route path="/rapports" element={<Protected perm="rapports"><Reports /></Protected>} />
                <Route path="/distribution" element={<Protected perm="distribution"><Distribution /></Protected>} />
                <Route path="/taches" element={<Protected perm="taches"><Taches /></Protected>} />
                <Route path="/crm" element={<Protected perm="crm"><Crm /></Protected>} />
                <Route path="/fournisseurs" element={<Protected perm="fournisseurs"><Suppliers /></Protected>} />
                <Route path="/points-de-vente" element={<Protected perm="points_de_vente"><PointsDeVente /></Protected>} />
                <Route path="/utilisateurs" element={<Protected perm="utilisateurs"><UsersPage /></Protected>} />
                <Route path="/integrations" element={<Protected perm="parametres"><ApiSettings /></Protected>} />
                <Route path="/activite" element={<Protected perm="utilisateurs"><ActivityLog /></Protected>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </PosProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
